import { filter, mapTo } from "rxjs/operators";
import { TypeActionModal } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionShopDeselectOffer } from "../actionShop";
export var epicShopOfferDeselect = function (action$, state$, deps) {
    return action$.pipe(filter(function (_a) {
        var type = _a.type, modalId = _a.modalId;
        return ((type === TypeActionModal.Close || type === TypeActionModal.CloseLast) &&
            modalId === IdModal.Shop);
    }), mapTo(actionShopDeselectOffer()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopOfferDeselect.ts
// module id = 2338
// module chunks = 3